// New translations for registration and email confirmation
const newTranslations = {
    // Registration and auth
    'registracija_sekme': 'Регистрация успешна!',
    'vardas': 'Имя',
    'pavarde': 'Фамилия',
    'ivestiVarda': 'Введите имя',
    'ivestiPavarde': 'Введите фамилию',
    'slaptazodzio_keitimas': 'Смена пароля',
    'current_password': 'Текущий пароль',
    'neteisingas_dabartinis_slaptazodis': 'Неверный текущий пароль',
    'profilis_atnaujintas': 'Профиль успешно обновлен!',
    'keisti_slaptazodi': 'Изменить',
    'slaptazodzio_keitimo_aprasymas': 'Мы отправим ссылку для смены пароля',
    'slaptazodzio_keitimo_nuoroda_issiusta': 'Ссылка для смены пароля отправлена',
    'registracijos_klaida': 'Пользователь с этим email уже зарегистрирован или не подтвержден',
    'sistemos_klaida': 'Произошла системная ошибка. Пожалуйста, попробуйте позже.',
    'registruojama': 'Регистрация...',
    'privalomi_laukai': 'Пожалуйста, заполните все обязательные поля',
    'prisijungimo_klaida': 'Ошибка входа. Ваша учетная запись не подтверждена администратором или проверьте email и пароль.',
    'jungiamasi': 'Подключение...',
    'user_exists': 'Пользователь с этим email уже зарегистрирован или не подтвержден',
    'esu_organizacijos_atstovas': 'Я уполномоченный представитель организации и могу создать учетную запись от имени организации',
    
    // Email confirmation
    'email_patvirtinimas': 'Подтверждение email',
    'tikrinamas_email': 'Проверка подтверждения вашего email...',
    'email_patvirtintas': 'Ваш email успешно подтвержден!',
    'email_patvirtintas_sekmes': 'Email успешно подтвержден! Теперь администратор должен подтвердить вашу учетную запись.',
    'email_patvirtintas_admin': 'Администратор должен подтвердить вашу учетную запись, прежде чем вы сможете использовать систему. Это может занять до 24 часов.',
    'patvirtinimo_klaida': 'Произошла ошибка при подтверждении email.',
    'truksta_parametru': 'Отсутствуют необходимые параметры подтверждения.',
    'netinkamas_patvirtinimo_tipas': 'Неверный тип подтверждения. Пожалуйста, попробуйте еще раз.',
    'grizti_i_prisijungima': 'Вернуться на страницу входа',
    
    // Admin confirmation
    'laukiama_admin_patvirtinimo': 'Ваша учетная запись ожидает подтверждения администратора',
    'jūsų_paskyra_laukia_administratoriaus_patvirtinimo': 'Ваш email успешно подтвержден, но перед использованием системы ваша учетная запись должна быть подтверждена администратором.',
    'gauti_patvirtinimą_gali_užtrukti_iki_24_val': 'Процесс подтверждения может занять до 24 часов. Вы получите уведомление по email, когда ваша учетная запись будет подтверждена.',
    'account_not_confirmed_by_admin': 'Ваша учетная запись еще не подтверждена администратором. Вы сможете использовать систему после того, как администратор подтвердит вашу учетную запись.',
    
    // Admin guide
    'vartotojų_patvirtinimas': 'Подтверждение пользователя',
    'nauji_vartotojai_turi_būti_patvirtinti_prieš_naudojimą': 'Новые пользователи должны быть подтверждены перед использованием системы.',
    'patvirtinti_vartotojai_gali_prisijungti_ir_naudotis_sistema': 'Подтвержденные пользователи могут войти и использовать систему.',
    'nepatvirtinti_vartotojai_negali_prisijungti': 'Неподтвержденные пользователи не могут полноценно использовать систему.',
    'vartotojai_kurių_el_paštas_nepatvirtintas_gali_neturėti_prieigos': 'Пользователи с неподтвержденным email могут не иметь доступа к системе.',
    
    // Registration success
    'registration_success_email_confirmation': 'Регистрация успешна! Проверьте свой email для подтверждения учетной записи.',
    
    // Company confirmation
    'patvirtinti_imone': 'Подтвердить компанию',
    'Vartotojas sėkmingai patvirtintas': 'Компания успешно подтверждена!',
    'Klaida patvirtinant vartotoją': 'Ошибка при подтверждении компании. Пожалуйста, попробуйте еще раз.',

    // Subscription
    'galioja_iki': 'Действительно до',
    'galiojanti': 'Действующая',
    'negaliojanti': 'Недействующая',
    'prenumeratos_info': 'Выберите тип подписки и сохраните изменения',
    'Įmonė sėkmingai patvirtinta!': 'Компания успешно подтверждена!',
    'Metai pridėti. Nepamirškite paspausti "Išsaugoti" mygtuką, kad pakeitimai būtų išsaugoti.': 'Годы добавлены. Не забудьте нажать кнопку "Сохранить", чтобы сохранить изменения.',
    'login_error': 'Неверный пароль или учетная запись не подтверждена',
    'db_migration_info': 'Если вы еще не изменили свой пароль, пожалуйста, нажмите "Забыли пароль", и мы отправим вам ссылку для смены пароля. База данных была перенесена на другие серверы, поэтому вам необходимо создать новый пароль.',

    // Forgot password
    'forgotPass.invalidEmail': 'Неверный формат email',
    'forgotPass.resetLinkSent': 'Ссылка для восстановления пароля отправлена',
    'forgotPass.resetError': 'Ошибка при отправке ссылки восстановления',

    // OTP verification
    'send_code': 'Отправить код',
    'verify_code': 'Подтвердить код',
    'resend_code': 'Отправить код повторно',
    'resend_code_in': 'Код можно отправить повторно через',
    'otp_sent': 'Код подтверждения отправлен!',
    'otp_resent': 'Новый код отправлен!',
    'invalid_otp': 'Неверный код. Попробуйте еще раз.',
    'verification_code': 'Код подтверждения',
    'otp_verification_desc': 'Введите полученный 6-значный код',
    'enter_6_digit_code': 'Введите 6-значный код'
};

export default newTranslations;
